import paredAnalytics from 'pared/analytics/utils/ParedAnalytics'

export const track = {
  async employeeDayPartChanged(dayPart: string) {
    await paredAnalytics.track('Guest - Employee Day Part', { dayPart })
  },
}
